import React from "react";
import Select from "react-select";

const SelectField = ({
  hidden,
  placeholder,
  register,
  errors,
  label,
  name,
  rules,
  options,
  defaultValue,
  setValue,
  onChange,
  useSearch = false,
  onSearchInputChange,
  className,
  styles,
  labelClassName,
  labelStyles,
  multiSelect = false,
  watch,
}) => {
  const handleReactSelectChange = (selected) => {
    const value = multiSelect
      ? (selected ? selected.map(s => s.value) : [])
      : (selected ? selected.value : "");

    setValue(name, value, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
    // Force re-render to update validation state
    setTimeout(() => {
      setValue(name, value, { shouldValidate: true });
    }, 0);
    if (onChange) {
      onChange(value);
    }
  };

  const handleInputChange = (inputValue) => {
    if (onSearchInputChange) {
      onSearchInputChange(inputValue);
    }
  };

  // Get current values from form state
  const currentValues = watch ? watch(name) : defaultValue;

  // Find the current option object(s) for React Select
  const currentOption = multiSelect
    ? (options?.filter(opt => currentValues?.includes(opt.value)) || [])
    : (options?.find((opt) => opt.value === currentValues) || null);

  // Register the field with React Hook Form
  const { onChange: rhfOnChange, onBlur: rhfOnBlur, name: fieldName, ref: fieldRef } = register(name, rules);

  return (
    <div
      className={`${
        hidden ? "hidden" : "flex"
      } flex-col items-start w-full ${className}`}
    >
      <label
        htmlFor={name}
        className={`form-label font-bold float-start mb-1 ${labelClassName}`}
        style={labelStyles}
      >
        {rules?.required && <span className="text-red-500">*</span>} {label}
      </label>

      {(useSearch || multiSelect) ? (
        <Select
          inputId={name}
          name={name}
          options={options}
          value={currentOption}
          onChange={handleReactSelectChange}
          onInputChange={handleInputChange}
          className="w-full"
          classNamePrefix="react-select"
          placeholder={placeholder}
          isClearable
          isMulti={multiSelect}
          styles={{
            ...styles,
            control: (provided) => ({
              ...provided,
              ...styles.control,
              height: multiSelect ? 'auto' : '48px',
              minHeight: multiSelect ? '48px' : '48px',
            }),
            placeholder: (provided) => ({
              ...provided,
              ...styles.placeholder,
            }),
            multiValue: (provided) => ({
              ...provided,
              ...styles.multiValue,
            }),
            multiValueLabel: (provided) => ({
              ...provided,
              ...styles.multiValueLabel,
            }),
            multiValueRemove: (provided) => ({
              ...provided,
              ...styles.multiValueRemove,
            }),
            ...(multiSelect ? {
              valueContainer: (provided) => ({
                ...provided,
                ...styles.valueContainer,
              }),
            } : {}),
          }}
        />
      ) : (
        <select
          defaultValue={defaultValue}
          onChange={(e) => {
            rhfOnChange(e); // React Hook Form's onChange
            // Also trigger validation
            setValue(name, e.target.value, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
            // Force re-render to update validation state
            setTimeout(() => {
              setValue(name, e.target.value, { shouldValidate: true });
            }, 0);
          }}
          onBlur={rhfOnBlur}
          name={fieldName}
          ref={fieldRef}
          className="block w-full border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 p-1"
          style={styles.control || styles}
        >
          <option value="">{placeholder}</option>
          {options &&
            options.map((opt, idx) => (
              <option key={idx} value={opt.value}>
                {opt.label}
              </option>
            ))}
        </select>
      )}

      {errors[name] && (
        <span className="text-red-500 text-sm mt-1">
         {errors[name].message}
        </span>
      )}
    </div>
  );
};

export default SelectField;
